module.exports = __webpack_public_path__ + "img/234.toilet_services.5813071c.svg";